import { RARITY_COLORS } from '../../data/items';
import { LootItemRow }   from '../atoms/LootItemRow';

/**
 * Game-over screen.
 * Shows final stats (score, level, kills, gold) and any items that dropped.
 * Items are automatically added to the player's inventory by App.js
 * as soon as gameState transitions to 'dead'.
 */
export function DeadScreen({ score, level, kills, gold, droppedItems = [], onRestart, onMenu }) {
  const hasLoot = droppedItems.length > 0;

  return (
    <div className="overlay dead-screen">
      <h1>Game Over</h1>

      <div className="dead-stats">
        <div className="dead-stat-row">
          <span className="dead-stat-label">🛤️ Distance</span>
          <span className="dead-stat-value">{score.toLocaleString()} pts</span>
        </div>
        <div className="dead-stat-row">
          <span className="dead-stat-label">🎯 Level</span>
          <span className="dead-stat-value">{level}</span>
        </div>
        <div className="dead-stat-row">
          <span className="dead-stat-label">⚔️ Kills</span>
          <span className="dead-stat-value">{kills ?? 0}</span>
        </div>
        <div className="dead-stat-row">
          <span className="dead-stat-label">💰 Gold</span>
          <span className="dead-stat-value dead-stat-gold">{gold ?? 0}</span>
        </div>
      </div>

      <div className="idle-buttons">
        <button onClick={onRestart}>▶ Play Again</button>
        <button className="btn-secondary" onClick={onMenu}>Main Menu</button>
      </div>

      {/* ── Loot section ─────────────────────────────────────────────────── */}
      <div className="loot-section">
        <div className="loot-header">
          {hasLoot
            ? `⚔️ Loot Collected — ${droppedItems.length} item${droppedItems.length > 1 ? 's' : ''} added to inventory`
            : '🎲 No loot dropped this run'}
        </div>

        {hasLoot && (
          <div className="loot-grid">
            {droppedItems.map((item, i) => (
              <LootItemRow
                key={`${item.id}_${i}`}
                item={item}
                color={RARITY_COLORS[item.rarity] ?? '#9e9e9e'}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
